import createModalSkeleton from "src/helpers/createModalSkeleton";

const { GatheringAdminPrivacyModalSkeleton, useGatheringAdminPrivacyModalDimensions } =
	createModalSkeleton({
		name: "GatheringAdminPrivacyModal",
		sizeVariant: "Medium",
	});
export { useGatheringAdminPrivacyModalDimensions };
export default GatheringAdminPrivacyModalSkeleton;
